import styled from '@emotion/styled'
import CloseIcon from '@mui/icons-material/Close'

import { LinkButton } from '../buttons/link-button'

const StyledLink = styled(LinkButton)`
  display: flex;
  align-items: center;
  padding: 0 36px;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: normal;
  flex: 0 1 auto;
  margin-left: auto;
`

export type CloseProps = {
  onClick?: () => void
}

export const Close = ({ onClick }: CloseProps) => (
  <StyledLink underline={false} onClick={() => onClick && onClick()}>
    <CloseIcon /> CLOSE
  </StyledLink>
)
